<script setup lang="ts">
import { useTemplateRef, ref } from "vue";
import Tooltip from "./Tooltip.vue";

withDefaults(
  defineProps<{
    placement?: "top" | "bottom" | "left" | "right";
    tooltipClass?: string;
    teleportTo?: string;
  }>(),
  {
    tooltipClass: "tooltip-button__tooltip",
    placement: "bottom",
    teleportTo: "#app"
  }
);

const mainButton = useTemplateRef("mainButton");
const tooltipVisible = ref(false);

function toggleTooltip() {
  tooltipVisible.value = !tooltipVisible.value;
}
</script>

<template>
  <button
    ref="mainButton"
    class="tooltip-button"
    @click="toggleTooltip()"
  >
    <Tooltip
      :target="mainButton"
      :visible="tooltipVisible"
      :placement="placement"
      :class="tooltipClass"
      @click:outside="tooltipVisible = false"
      :teleport-to="teleportTo"
    >
      <slot name="tooltip"></slot>
    </Tooltip>
    <slot></slot>
  </button>
</template>

<style lang="scss">
.tooltip-button {
  &__tooltip {
    background-color: var(--color-background-deep);
    box-shadow:
      0 2px 10px rgba(0, 0, 0, 0.12),
      0 2px 5px rgba(0, 0, 0, 0.16);
    padding: 0.25rem;
    border-radius: 0.5rem;
  }
}
</style>